import React, { PureComponent } from 'react';
import axios from 'axios';
import { Glyphicon, Row, Col, Button } from 'react-bootstrap';
import { arrayMove } from 'react-sortable-hoc';
import GroupLinksSortable from './groupLinksSortable';
import appConstant from '../../../../../constants/app';

class GroupLinksEdit extends PureComponent {
  onFormSubmit = (e) => {
    e.preventDefault() // Stop form submit

    const data = this.props.groupLinksSection.map((item, index) => ({
      id: item.id,
      position: index + 1,
      hidden: item.pivot.hidden,
      sectionId: item.pivot.section_id,
    }));
    
    axios({
      method: 'post',
      url: `${appConstant.API_URL}/section/links/update?access_token=${localStorage.getItem('token')}`, 
      data: {
        id: data[0].sectionId,
        links: data,
      },
    })
    .then(res => {
      console.log('success');
      this.props.onClickCancelEdit(res.data.section.parent_id)
    }).catch(err => {
      console.log(err);
    });
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    const {
      onChangeGroupsLinksList,
      groupLinksSection,
    } = this.props;

    const groupLinksItems = arrayMove(groupLinksSection, oldIndex, newIndex);
    onChangeGroupsLinksList(groupLinksItems);
  };

  render() {
    const {
      groupSection,
      groupLinksSection,
      addGroupLinkItem,
      deleteItem,
      hideItem,
      onClickCancelEdit,
    } = this.props;

    return (
      <div className="groupLinks-container">
        <form onSubmit={this.onFormSubmit}>
          <Row>
            <Col sm={12}>
              {
                groupLinksSection.length ?
                <GroupLinksSortable
                  items={groupLinksSection}
                  pressDelay={200}
                  onSortEnd={this.onSortEnd}
                  deleteItem={deleteItem}
                  hideItem={hideItem}
                />
                :
                <p className="no-group-links">
                  To save, you must add at least one link.
                </p>
              }
              <div
                className="new-menu-link"
                onClick={() => {
                  addGroupLinkItem(groupSection.id)
                }}
              >
                <Glyphicon glyph="plus" />
                Add item
              </div>
            </Col>
          </Row>
          <Row
            className="buttons-row header-edit-btns">
            <Col sm={8}>
              <Button
                className="cancel-btn"
                onClick={() => {
                  onClickCancelEdit(groupSection.parent_id)
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="accept-btn"
                disabled={!groupLinksSection.length}
              >
                Save changes
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    )
  }
}

export default GroupLinksEdit;


// WEBPACK FOOTER //
// ./src/app/screens/sections/groupsSection/groupLinksSection/groupLinksEdit.js